import { Component, Input, OnInit } from '@angular/core';
import { CRMItem } from '../../models/crm/CRMItem.model';
import { CRMStatusLabels } from '../../models/crm/CRMStatus';
import { CrmStatusService } from '../../../core/data-services/crm-status.service';
import { StructCapCRMItem } from '../../models/crm/struct-cap/StructCapCRMItem.model';
import { STRUCT_CAP_URL_ROOT } from 'src/app/modules/crm/struct-cap-crm/struct-cap-crm-parent/struct-cap-crm-parent.component';
import { StructCapCRMStatusLabels } from '../../enums/struct-cap-crm-status';
import { User } from '../../models';

@Component({
    selector: 'rms-crm-archived-table',
    templateUrl: './crm-archived-table.component.html',
    styleUrls: ['./crm-archived-table.component.scss'],
    standalone: false
})
export class CrmArchivedTableComponent implements OnInit {

  @Input() crmItems: Array<CRMItem>;
  @Input() structCapCrmItems: Array<StructCapCRMItem>;

  public isOpen = false;

  public readonly statusLabels = CRMStatusLabels;
  public readonly structCapStatusLabels = StructCapCRMStatusLabels;
  public readonly SONAR_ITEM_ROUTE = '/sonar/item/';
  public readonly STRUCT_CAP_ITEM_ROUTE = `/sonar/${STRUCT_CAP_URL_ROOT}/item/`;

  constructor(
    public crmStatusService: CrmStatusService,
  ) { }

  ngOnInit() {
  }

  public getParticipantName(user: {updated: Date, created: Date, user: User, confirmed: boolean}) {
    return user.user.fullName;
  }

  get archivedItems(): Array<CRMItem> {
    if (this.crmItems) {
      return this.crmItems.filter(c => c.archived);
    }
    return [];
  }

  get structCapArchivedItems(): Array<StructCapCRMItem> {
    if (this.structCapCrmItems) {
      return this.structCapCrmItems.filter(c => c.archived);
    }
    return [];
  }
}
